import React from 'react';

import component, {classnames} from './component';
import Link from './Link';
import {ArrowRight} from './icons';

export default component('ActionButton', function({data, className, name, text,
    icon, arrow, onClick}) {

  return (
    <div className={classnames(
      'ActionButton', className, {
        'ActionButton--Text': text,
        'ActionButton--Icon': icon,
        'ActionButton--NoClick': !onClick
      }
    )} onClick={onClick}>
      {text &&
        <div className='ActionButton-Text'>{text}</div>
      }
      {arrow &&
        <ArrowRight className='ActionButton-Arrow' />
      }
      {icon &&
        <div className='ActionButton-Icon'>{icon}</div>
      }
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/ActionButton.js